export { NKDatetime } from './src/ng2-datetime/ng2-datetime';
export { NKDatetimeModule } from './src/ng2-datetime/ng2-datetime.module';



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/ng2-datetime/ng2-datetime.ts